import { useSearchParams } from "react-router-dom";
import CreateTemplate from "layouts/template/CreateTemplate";
import StaticTemplateForm from "layouts/template/components/StaticTemplate";

const TEMPLATE_TYPE = {
  STATIC: "static",
  FULLY_AI: "dynamic",
};

function TemplateForm() {
  const [searchParams] = useSearchParams();

  const templateFormat = searchParams.get("templateFormat");

  if (templateFormat === TEMPLATE_TYPE.FULLY_AI) {
    return <CreateTemplate />;
  }

  return <StaticTemplateForm />;
}

export default TemplateForm;
